module.exports = __webpack_public_path__ + "img/payment-logos-paypal.b4f059b7.png";